// extracted by mini-css-extract-plugin
export default {"cls1":"Timer-cls1_Wsu","cls2":"Timer-cls2_Ir6 Timer-cls1_Wsu","withoutHours":"Timer-withoutHours_hWe","mini":"Timer-mini_F7k"};